import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { AlertService } from '../alert.service';
import { EnvService } from '../env.service';
import { PurchaseService } from '../services/purchase.service';
import { StudioService } from '../services/studio.service';
export class PurchaseStudioComponent {
    constructor(router, loadingCtrl, studioService, route, env, purchaseService, alertCtrl, alertService) {
        this.router = router;
        this.loadingCtrl = loadingCtrl;
        this.studioService = studioService;
        this.route = route;
        this.env = env;
        this.purchaseService = purchaseService;
        this.alertCtrl = alertCtrl;
        this.alertService = alertService;
        this.items = [];
        this.studio = {};
        this.isLoading = false;
        this.purchaseData = {};
        this.paymentAmount = '2.99';
        this.currency = 'USD';
        this.currencyIcon = '$';
        this.cardDetails = {};
        this.stripe = Stripe(this.env.STRIPE_KEY);
        this.elements = this.stripe.elements();
        this.stripeData = {};
        this.purchaseUI = {};
        this.storeCard = false;
        this.plan = {};
        this.completeBooking = () => {
            if (this.displayError) {
                this.presentAlert(this.displayError);
            }
            else {
                this.showLoader();
                this.purchaseData.token = '';
                const isFormShown = !this.storedCardLast4 || this.purchaseData.update_card;
                if (isFormShown == true) {
                    if (this.cardNumberElement._complete == false) {
                        this.presentAlert("Please enter a valid credit card number.");
                        this.hideLoader();
                        return;
                    }
                    if (this.cardExpiryElement._complete == false) {
                        this.presentAlert('Please enter valid expiration date format e.g. "12/21"');
                        this.hideLoader();
                        return;
                    }
                    if (this.cardCvcElement._complete == false) {
                        this.presentAlert('Please enter valid cvc number');
                        this.hideLoader();
                        return;
                    }
                }
                if (!this.storedCardLast4 || this.purchaseData.store_card || this.purchaseData.update_card) {
                    this.stripe.createToken(this.cardNumberElement)
                        .then((result) => {
                        this.purchaseData.token = result.token.id;
                        this.purchaseService.buyStudioTermPlan(this.studioId, this.purchaseData).subscribe(data => {
                            this.processPayment(data);
                        });
                    })
                        .catch(error => {
                        this.alertService.presentToast('Payment Failed');
                        this.hideLoader();
                    });
                }
                else {
                    this.purchaseService.buyStudioTermPlan(this.studioId, this.purchaseData).subscribe(data => {
                        this.processPayment(data);
                    });
                }
            }
        };
        this.processPayment = (data) => {
            const parsedResponseData = data;
            if (parsedResponseData.status === true) {
                this.router.navigate(['venue', this.studioId, 'buy', this.planId, 'result'], {});
                this.hideLoader();
            }
            else {
                if (data.error) {
                    this.alertService.presentToast(data.error.message ? data.error.message : 'Payment Failed');
                    this.hideLoader();
                }
            }
        };
        this.updateCard = () => {
            this.purchaseData.update_card = true;
        };
        this.cancelUpdateCard = () => {
            // reset stripe data
            this.stripeData = {
                number: '',
                cvc: '',
                exp_month: '',
                exp_year: ''
            };
            this.purchaseData.update_card = false;
        };
        this.storeCardChange = () => {
            // store card for future use
            this.purchaseData.store_card = this.storeCard;
        };
        this.setupStripe = () => {
            // if (this.storedCardLast4 === '' || this.purchaseData.update_card === true) {
            this.elements = this.stripe.elements();
            const style = {
                base: {
                    iconColor: '#666EE8',
                    color: '#31325F',
                    '::placeholder': {
                        color: '#CFD7E0',
                    },
                },
            };
            this.cardNumberElement = this.elements.create('cardNumber', {
                style,
                placeholder: 'Credit Card Number',
            });
            this.cardNumberElement.mount('#card-number-element');
            this.cardExpiryElement = this.elements.create('cardExpiry', {
                style,
                placeholder: 'MM/YY',
            });
            this.cardExpiryElement.mount('#card-expiry-element');
            this.cardCvcElement = this.elements.create('cardCvc', {
                style,
                placeholder: 'CVC',
            });
            this.cardCvcElement.mount('#card-cvc-element');
            this.cardNumberElement.on('ready', (event) => {
                // Handle ready event
                this.hideLoader();
                this.purchaseUI.stripeReady = true;
            });
            this.cardNumberElement.on('change', (event) => {
                if (event.error) {
                    this.displayError = event.error.message;
                }
                else {
                    this.displayError = '';
                }
            });
            this.cardExpiryElement.on('change', (event) => {
                if (event.error) {
                    this.displayError = event.error.message;
                }
                else {
                    this.displayError = '';
                }
            });
            this.cardCvcElement.on('change', (event) => {
                if (event.error) {
                    this.displayError = event.error.message;
                }
                else {
                    this.displayError = '';
                }
            });
            // }
        };
        this.setOutcome = (result) => {
            const successElement = document.querySelector('.success');
            const errorElement = document.querySelector('.error');
            successElement.classList.remove('visible');
            errorElement.classList.remove('visible');
        };
        this.route.params.subscribe((params) => {
            if (params.id && params.planId) {
                this.studioId = params.id;
                this.planId = params.planId;
                this.showLoader();
                this.getStudioDetails();
            }
        });
        this.items = [
            { expanded: false, title: 'What happens after I buy?', desc: 'Within 24 hours you\'ll receive an email receipt confirming that your purchase has been processed. During times of high site traffic, please, allow the full 24 hours for your receipt to arrive through email. If the purchase is successfully processed you can go to My Purchases for purchase information or My Reservations to view or edit your reservations.' },
            { expanded: false, title: 'Can I cancel what I bought?', desc: 'Yes, you can cancel your purchase up until the 48 hours of your purchase or 48 hours of the first reserved session, which ever occurs first - once you have passed the 48 hours after the purchase or 48 hours before your first reserved session, you can no longer cancel your purchase for a refund. You\'ll see all your purchases on \'My Purchases\' with a link to \'Cancel my purchase\' where appropriate. However, if the purchase is FREE then you can cancel up until the 24 hours of the first reserved session.' },
            { expanded: false, title: 'Is this safe?', desc: 'Yes! Both us and our secure payment partner Stripe have controls that are designed to reasonably safeguard your information; for example, we use industry-standard encryption technology to secure your personal and payment information. You can read more in the Privacy Policy.' }
        ];
    }
    ngOnInit() {
        this.setupStripe();
        this.purchaseData['ismobile'] = true;
    }
    getStudioDetails() {
        this.studioService.getStudio(this.studioId, {}).subscribe((response) => {
            this.hideLoader();
            this.studio = response.result;
            let planId = this.planId;
            this.plan = this.studio.term_prices.filter(function (plan) {
                return parseInt(plan.id) === parseInt(planId);
            })[0];
            this.purchaseData.plan = this.plan.pivot.id;
        });
    }
    presentAlert(msg) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: msg,
                cssClass: 'ui-waiver',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    showLoader() {
        this.isLoading = true;
        this.loadingCtrl
            .create({
            message: 'Loading...',
        })
            .then((res) => {
            res.present().then(() => {
                //To avoid loader overlapping
                if (!this.isLoading) {
                    res.dismiss().then(() => { });
                }
            });
            res.onDidDismiss().then((dis) => { });
        });
    }
    hideLoader() {
        this.isLoading = false;
        this.loadingCtrl.dismiss();
    }
    expandItem(item) {
        if (item.expanded) {
            item.expanded = false;
        }
        else {
            this.items.map(listItem => {
                if (item == listItem) {
                    listItem.expanded = !listItem.expanded;
                }
                else {
                    listItem.expanded = false;
                }
                return listItem;
            });
        }
    }
}
